(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["product-slider"] && !window.DesignMode) return;
  try {
    

function process_slick_event(evt) {
  var _slick = $( "#" +evt.target.id + " .product-slider");
  if( _slick.length )
  {
    switch ( evt.originalEvent.type ) {
      case "shopify:section:load" : 
        console.log('Load ' + _slick.attr("id"));
        _slick.slick (
            {
              slidesToShow: _slick.data('slick').slidesToShow,
              slidesToScroll: 1,
            arrows: true,
              autoplay: _slick.data('slick').autoplay,
              autoplaySpeed: _slick.data('slick').autoplaySpeed,
              responsive: [ 
						{
                            breakpoint: 480,
                            settings: {
                              slidesToShow: 2
                          }
                        }
                      ]
            }
          );
      break; 
      case "shopify:section:unload" :
        console.log('Unload ' + _slick.attr("id"));
        _slick.slick('unslick');
      break;

     } 
  }
}
    
document.addEventListener( 'DOMContentLoaded', function () {
  $(document)
   .on( 'shopify:section:load shopify:section:unload', process_slick_event );
}, false );

  } catch(e) { console.error(e); }
})();

})();
